import React from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Ub04Form } from '../../../services/ub04Service';
import { Cms1500Form } from '../../../services/cms1500Service';
import { getFormDisplayName } from '../utils/formHelpers';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
}));

interface FormTabsProps {
  forms: (Ub04Form | Cms1500Form)[];
  currentIndex: number;
  onTabChange: (event: React.ChangeEvent<unknown>, newValue: number) => void;
}

/**
 * Component for displaying tabs for multiple forms
 */
const FormTabs: React.FC<FormTabsProps> = ({ forms, currentIndex, onTabChange }) => {
  const classes = useStyles();

  // Don't render tabs if there's only one form
  if (forms.length <= 1) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <Tabs
        value={currentIndex}
        onChange={onTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {forms.map((form, index) => (
          <Tab
            key={index}
            label={`${getFormDisplayName(form, index)}${form.isDirty ? ' *' : ''}`}
          />
        ))}
      </Tabs>
    </Paper>
  );
};

export default FormTabs;
